import Vue from 'vue';
import apiKeysServices from './api/api-keys';
import appServices from './api/app';
import appLogsServices from './api/app-logs';
import appSystemServices from './api/app-system';
import appSystemsServices from './api/app-systems';
import appSystemWebApisServices from './api/app-system-web-apis';
import authServices from './api/auth';
import callLogsServices from './api/call-logs';
import contactIdMappingsServices from './api/contact-id-mappings';
import documentsServices from './api/documents';
import dynamicFormServices from './api/dynamic-form';
import fieldMappingServices from './api/field-mapping';
import httpMethodLookupServices from './api/http-method-lookup';
import integrationCallsServices from './api/integration-calls';
import integrationTasksServices from './api/integration-tasks';
import locationsServices from './api/locations';
import meServices from './api/me';
import onlinePaymentTransactionServices from './api/online-payment-transaction';
import processesServices from './api/processes';
import recurringMembershipPaymentsServices from './api/recurring-membership-payments';
import sequencenumbersServices from './api/sequencenumbers';
import tenantsServices from './api/tenants';
import usersServices from './api/users';
import widgetAnimaturaServices from './api/widget-animatura';
import widgetAnimaturaTopicsServices from './api/widget-animatura-topics';
import widgetMembershipsServices from './api/widget-memberships';
import widgetMembershipTemplatesServices from './api/widget-membership-templates';
import widgetNimSServices from './api/widget-nim-s';
import widgetNimSCertificatsServices from './api/widget-nim-s-certificats';
import widgetNimSGardenAdvicesServices from './api/widget-nim-s-garden-advices';
import widgetNimSGardenCertificationsServices from './api/widget-nim-s-garden-certifications';
import widgetNimSGardenTypesServices from './api/widget-nim-s-garden-types';
import widgetNimSTopicsServices from './api/widget-nim-s-topics';
import widgetOMServices from './api/widget-om';

export default () => ({
  apiKeys: { ...apiKeysServices(Vue.$service) },
  app: { ...appServices(Vue.$service) },
  appLogs: { ...appLogsServices(Vue.$service) },
  appSystem: { ...appSystemServices(Vue.$service) },
  appSystems: { ...appSystemsServices(Vue.$service) },
  appSystemWebApis: { ...appSystemWebApisServices(Vue.$service) },
  auth: { ...authServices(Vue.$service) },
  callLogs: { ...callLogsServices(Vue.$service) },
  contactIdMappings: { ...contactIdMappingsServices(Vue.$service) },
  documents: { ...documentsServices(Vue.$service) },
  dynamicForm: { ...dynamicFormServices(Vue.$service) },
  fieldMapping: { ...fieldMappingServices(Vue.$service) },
  httpMethodLookup: { ...httpMethodLookupServices(Vue.$service) },
  integrationCalls: { ...integrationCallsServices(Vue.$service) },
  integrationTasks: { ...integrationTasksServices(Vue.$service) },
  locations: { ...locationsServices(Vue.$service) },
  me: { ...meServices(Vue.$service) },
  onlinePaymentTransaction: { ...onlinePaymentTransactionServices(Vue.$service) },
  processes: { ...processesServices(Vue.$service) },
  recurringMembershipPayments: { ...recurringMembershipPaymentsServices(Vue.$service) },
  sequencenumbers: { ...sequencenumbersServices(Vue.$service) },
  tenants: { ...tenantsServices(Vue.$service) },
  users: { ...usersServices(Vue.$service) },
  widgetAnimatura: { ...widgetAnimaturaServices(Vue.$service) },
  widgetAnimaturaTopics: { ...widgetAnimaturaTopicsServices(Vue.$service) },
  widgetMemberships: { ...widgetMembershipsServices(Vue.$service) },
  widgetMembershipTemplates: { ...widgetMembershipTemplatesServices(Vue.$service) },
  widgetNimS: { ...widgetNimSServices(Vue.$service) },
  widgetNimSCertificats: { ...widgetNimSCertificatsServices(Vue.$service) },
  widgetNimSGardenAdvices: { ...widgetNimSGardenAdvicesServices(Vue.$service) },
  widgetNimSGardenCertifications: { ...widgetNimSGardenCertificationsServices(Vue.$service) },
  widgetNimSGardenTypes: { ...widgetNimSGardenTypesServices(Vue.$service) },
  widgetNimSTopics: { ...widgetNimSTopicsServices(Vue.$service) },
  widgetOM: { ...widgetOMServices(Vue.$service) },
});
